function ShowFullName(props: { firstName: string; lastName: string }): JSX.Element {
  return (
    <>
      {props?.firstName} {props?.lastName}
    </>
  )
}

export default ShowFullName
